var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.02532C4 2.90677 4.89543 2 6 2H18C19.1046 2 20 2.90677 20 4.02532V20.2278C20 21.0623 19.0592 21.5387 18.4 21.038L16.6 19.6709C16.2444 19.4008 15.7556 19.4008 15.4 19.6709L12.6 21.7975C12.2444 22.0675 11.7556 22.0675 11.4 21.7975L8.6 19.6709C8.24444 19.4008 7.75556 19.4008 7.4 19.6709L5.6 21.038C4.94076 21.5387 4 21.0623 4 20.2278V4.02532ZM6.25 7.06329C6.25 7.48275 6.58579 7.82278 7 7.82278H17C17.4142 7.82278 17.75 7.48275 17.75 7.06329C17.75 6.64383 17.4142 6.3038 17 6.3038H7C6.58579 6.3038 6.25 6.64383 6.25 7.06329ZM7 10.3544C6.58579 10.3544 6.25 10.6945 6.25 11.1139C6.25 11.5334 6.58579 11.8734 7 11.8734H17C17.4142 11.8734 17.75 11.5334 17.75 11.1139C17.75 10.6945 17.4142 10.3544 17 10.3544H7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketAlt);
export default __webpack_public_path__ + "static/media/ticket-alt.0c57a342a1cc1df1dfaad3e2e9217a40.svg";
export { ForwardRef as ReactComponent };